import React, { useEffect, useContext, useState } from 'react'
import { APIContext } from '../../../utils/api'
import styles from './styles.module.css'

// component function
export default function GetMoreAnalyses() {

	const context = useContext(APIContext)
	const [plans, setPlans] = useState()

	// get account types/prices
	useEffect(() => {
		context.io.socket.get('/api/v2/subscription/config', (data, res) => {
			if (res.statusCode === 200) {
				setPlans(data.plans)
			} else {
				// TODO: error handling
			}
		})
	}, [context.io.socket])

	// go to payment page
	function goBuy(id) {
		window.location.href='https://flowsam.ai/buy/?s=' + id
	}

	const priceAdhoc = plans?.find(plan => plan.id === 12)?.config?.Price // Ad hoc single analysis
	const priceUnlimited = plans?.find(plan => plan.id === 13)?.config?.Monthly_ex_VAT_Monthly_billing // Unlimited subscription

	return (
		<>
			<div className={styles.sectionHeading}>1. Get more flowsam<sup>®</sup> analyses</div>
			<div className={styles.container}>
				<div className={styles.ctaBoxContainer}>
					<div className={styles.ctaBox}>
						<div className={styles.product}>1 ad hoc analysis</div>
						<div className={styles.price}>{priceAdhoc}€</div>
						<div className={styles.ctaBtn} onClick={e=>goBuy(12)}>BUY</div>
					</div>
					<div className={styles.description}>Buy ad hoc analyses when you need them. Perfect if you perform less than {Math.floor(priceUnlimited/priceAdhoc)+1} analyses/month.</div>
				</div>
				<div className={styles.ctaBoxContainer}>
					<div className={styles.ctaBox}>
						<div className={styles.product}>Flowsam<sup>®</sup> Unlimited</div>
						<div className={styles.price}>{priceUnlimited}€/month</div>
						<div className={styles.ctaBtn} onClick={e=>goBuy(13)}>SUBSCRIBE</div>
					</div>
					<div className={styles.description}>Perform as many analyses as you like. Perfect for multiple iterations, cutdowns and A/B tests.</div>
				</div>
			</div>
		</>
	)
}
